// localstorage tokens definitions
export const AuthTokenKey = '@AUTH_TOKEN'
